import "./complaintManagement.css";

const ConversationTimeline = ({ timeline = [] }) => {
  if (!timeline.length) {
    return <p className="cmp-empty-text">No conversation history yet.</p>;
  }

  const groupedByDate = timeline.reduce((acc, item) => {
    const key = item.date || "Today";
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const hasDates = timeline.some((item) => item.date);

  if (hasDates) {
    return (
      <div className="cmp-timeline">
        {Object.entries(groupedByDate).map(([date, items]) => (
          <div key={date} className="cmp-timeline-group">
            <div className="cmp-timeline-date">{date}</div>
            {items.map((item, idx) => (
              <TimelineItem
                key={item.id}
                item={item}
                isLast={idx === items.length - 1}
              />
            ))}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="cmp-timeline">
      {timeline.map((item, idx) => (
        <TimelineItem
          key={item.id}
          item={item}
          isLast={idx === timeline.length - 1}
          showTime
        />
      ))}
    </div>
  );
};

const TimelineItem = ({ item, isLast, showTime }) => (
  <div className="cmp-timeline-item">
    <div className="cmp-timeline-marker">
      <div className="cmp-timeline-dot" />
      {!isLast && <div className="cmp-timeline-line" />}
    </div>
    <div className="cmp-timeline-content">
      {(showTime || item.time) && (
        <span className="cmp-timeline-time">{item.time}</span>
      )}
      <span className="cmp-timeline-actor">{item.actor}</span>
      <p className="cmp-timeline-message">{item.message}</p>
    </div>
  </div>
);

export default ConversationTimeline;
